import Vue from 'vue'
import { api } from '@/api/client'
import { inviteQuery } from '@/utils/channel'

export const downloadState = Vue.observable({
  ready: false,
  landing: null,
})

function landingUrl(landing, platform) {
  const downloads = landing && landing.downloads
  const pack = downloads && downloads[platform]
  return String((pack && pack.downloadUrl) || '').trim()
}

function goToDownloadUrl(url) {
  window.location.href = url
}

let loadingEl = null
let loadingTimer = null

function loadingTextEl() {
  return loadingEl && loadingEl.querySelector('p')
}

function loadingSpinnerEl() {
  return loadingEl && loadingEl.querySelector('.download-loading-spinner')
}

function setLoadingText(text) {
  const node = loadingTextEl()
  if (node) node.textContent = text
}

export function showDownloadLoading(text) {
  if (loadingTimer) {
    clearTimeout(loadingTimer)
    loadingTimer = null
  }
  if (!loadingEl) {
    loadingEl = document.createElement('div')
    loadingEl.className = 'download-loading-mask'
    loadingEl.innerHTML = '<div class="download-loading-box"><div class="download-loading-spinner"></div><p></p></div>'
    document.body.appendChild(loadingEl)
  }
  const spinner = loadingSpinnerEl()
  if (spinner) spinner.style.display = ''
  setLoadingText(text || '正在准备下载，请稍候...')
  loadingTimer = setTimeout(() => hideDownloadLoading(), 30000)
}

export function showDownloadNotice(text) {
  showDownloadLoading(text || '没有下载包')
  const spinner = loadingSpinnerEl()
  if (spinner) spinner.style.display = 'none'
  if (loadingTimer) clearTimeout(loadingTimer)
  loadingTimer = setTimeout(() => hideDownloadLoading(), 1800)
}

export function hideDownloadLoading(delayMs) {
  if (loadingTimer) {
    clearTimeout(loadingTimer)
    loadingTimer = null
  }
  if (delayMs) {
    loadingTimer = setTimeout(() => hideDownloadLoading(), delayMs)
    return
  }
  if (loadingEl) {
    loadingEl.remove()
    loadingEl = null
  }
}

let prefetchKey = ''
let prefetchPromise = null
let cachedLanding = null

/** 打开页只拉站点 + 安装包，不带 event / platform。 */
export function prefetchClientDownload() {
  const q = inviteQuery()
  const key = `${q.code}|${q.shareId}|${q.agentId}|${q.channel}`
  if (prefetchPromise && prefetchKey === key) return prefetchPromise

  prefetchKey = key
  prefetchPromise = api.inviteLanding({}).then((vo) => {
    cachedLanding = vo
    downloadState.landing = vo || null
    downloadState.ready = true
    return vo
  }).catch(() => {
    downloadState.ready = true
    return null
  })

  return prefetchPromise
}

function backendPackUrl(landing, platform) {
  return landingUrl(landing, platform) || landingUrl(cachedLanding, platform)
}

/** 点 Windows / Android / macOS：先出提示，再按后端 downloads[platform].downloadUrl 跳转。没有包就提示。iOS 走网页登录，不调这里。 */
export async function openClientDownload(platform) {
  if (platform === 'ios') return ''

  showDownloadLoading('正在准备下载，请稍候...')
  try {
    const landing = await api.inviteLanding({
      event: 'download',
      platform,
    })
    cachedLanding = landing
    downloadState.landing = landing || null

    const url = backendPackUrl(landing, platform)
    if (!url) {
      showDownloadNotice('没有下载包')
      return ''
    }
    goToDownloadUrl(url)
    hideDownloadLoading(1600)
    return url
  } catch (err) {
    const url = backendPackUrl(null, platform)
    if (url) {
      goToDownloadUrl(url)
      hideDownloadLoading(1600)
      return url
    }
    showDownloadNotice('没有下载包')
    return ''
  }
}
